// src/i18n/en/hotels.js
const hotels = {
    name: 'Hotel |||| Hotels',
    title: 'Hotel Management',
    titles: {
        list: 'Hotels',
        create: 'New Hotel',
        edit: 'Edit Hotel',
        show: 'Hotel Details',
    },
    fields: {
        id: 'ID',
        name: 'Name',
        group: 'Group',
        groupId: 'Group',
        groupName: 'Group',
        address: 'Address',
        city: 'City',
        country: 'Country',
        postalCode: 'Postal Code',
        phone: 'Phone',
        email: 'Email',
        defaultLanguage: 'Default Language',
        installationCode: 'Installation Code',
        isActive: 'Active',
        settings: 'Settings',
        zones: 'Zones',
        lockerCount: 'Total lockers',
        userCount: 'Users',
        createdAt: 'Created',
        updatedAt: 'Updated',
        users: 'Users',
        lockers: 'Lockers',
        status: 'Status',
        
        // Reference fields and tag types
        title: 'Reference Fields',
        reference_fields: 'Reference Fields',
        supported_tag_types: 'Supported Tag Types',
        no_reference_fields: 'No reference fields configured. Click "Add" to create one.',
        no_tag_types_available: 'No tag types available. Contact system administrator.',
        
        // Field form
        add_field: 'Add Field',
        edit_field: 'Edit Field',
        delete_field: 'Delete Field',
        delete_field_confirm: 'Are you sure you want to delete the field "{label}" ({key})?',
        delete_warning: 'This action cannot be undone.',
        
        field_key: 'Field Key',
        field_key_help: 'Unique identifier (e.g., "room_number", "guest_name")',
        field_label: 'Label',
        field_label_help: 'Label shown to users',
        field_mandatory: 'Mandatory Field',
        field_order: 'Display Order',
        field_order_help: 'Lower numbers appear first',
        
        // Messages
        field_saved: 'Field saved successfully',
        field_deleted: 'Field deleted successfully',
        configuration_saved: 'Configuration saved successfully',
        error_saving: 'Error saving configuration',
        field_key_required: 'Field key and label are required',
        field_key_unique: 'Field key must be unique',
        
        // Tag types
        tag_type_system: 'System',
        tag_type_manual: 'Manual',
        select_tag_types: 'Select the tag types this hotel can use',
        
        // Branding fields
        primary_color: 'Primary Color',
        logo: 'Logo',
        
        // Custom texts fields
        language: 'Language',
        custom_texts: 'Custom Texts',
        text_key: 'Text Key',
        text_value: 'Text Value',
        
        // Additional HotelFields translations
        count: '%{current} of %{max} fields configured',
        subtitle: 'Configure up to 5 custom fields for additional information',
        no_fields: 'No fields configured',
        no_fields_description: 'Reference fields allow you to capture additional custom information',
        create_first_field: 'Create first field',
        new_field: 'New field',
        mandatory: 'Mandatory',
        key: 'Key',
        display_order: 'Display order',
        move_up: 'Move up',
        move_down: 'Move down',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        create: 'Create',
        update: 'Update',
        saving: 'Saving...',
        deleting: 'Deleting...',
        saved_success: 'Fields saved successfully',
        save_error: 'Error saving fields',
        save_changes: 'Save changes',
        load_error: 'Error loading fields',
        label_required: 'Field name is required',
        key_required: 'Field key is required',
        key_format_error: 'Key must start with lowercase letter and contain only lowercase letters, numbers and underscores',
        key_exists: 'A field with that key already exists',
        label_helper: 'Visible name for users',
        key_helper: 'Unique identifier (only lowercase letters, numbers and underscores)',
        max_fields_warning: 'Cannot add more than 5 fields',
        max_fields_reached: 'You have reached the maximum limit of 5 reference fields',
        unsaved_changes: 'You have unsaved changes',
        delete_confirm: 'Are you sure you want to delete the field \'%{name}\'?',
        no_permissions_delete: 'You do not have permission to delete fields',
    },
    
    alert_config: {
        title: 'Alert Configuration',
        subtitle: 'Manage recipients and severity level for system alerts',
        email_service_title: 'Email Service Configuration',
        email_service_subtitle: 'Configure integration with the email notification service',
        
        // Severity levels
        debug: 'Debug',
        info: 'Information',
        warning: 'Warning',
        error: 'Error',
        critical: 'Critical',
        
        // Form labels
        min_severity_label: 'Minimum Severity Level',
        min_severity_help: 'Only notifications for alerts with this severity level or higher will be sent',
        recipients_title: 'Alert Recipients',
        email_label: 'Email',
        api_key_label: 'API Key',
        account_name_label: 'Roommatik Notify service account name',
        account_name_placeholder: 'Roommatik Notify service account name',
        template_title: 'QR code email template',
        template_label: 'Select Template',
        template_placeholder: 'Select a template',
        
        // Connection status
        connected: 'Connected',
        no_connection: 'No connection',
        untested: 'Not tested',
        
        // Actions
        add: 'Add',
        save_config: 'Save Configuration',
        saving: 'Saving...',
        update_api_key: 'Update API Key',
        config_api_key: 'Configure API Key',
        test_connection: 'Test Connection',
        testing: 'Testing...',
        continue_editing: 'Continue editing',
        exit_without_saving: 'Exit without saving',
        loading: 'Loading...',
        
        // Messages
        no_recipients: 'No recipients configured',
        email_required: 'Enter an email',
        email_invalid: 'Invalid email',
        email_exists: 'This email is already in the list',
        api_key_current_placeholder: '••••••••',
        api_key_placeholder: 'Enter the API Key',
        api_key_keep_help: 'Leave empty to keep current configuration',
        api_key_required_help: 'Required to enable email sending',
        connection_warning: 'API Key is saved but connection could not be verified. Emails will not be sent until a valid connection is established.',
        
        // Success/Error messages
        load_error: 'Error loading configuration',
        connection_success: 'Successful connection',
        connection_failed: 'Could not connect. Check your API Key',
        connection_test_error: 'Error testing connection',
        api_key_saved: 'API Key saved successfully',
        connection_verified: 'Connection verified correctly',
        api_key_saved_no_connection: 'API Key saved but no active connection',
        api_key_save_error: 'Error saving API Key',
        template_updated: 'Template updated successfully',
        template_update_error: 'Error updating template',
        hotel_load_error: 'Could not load hotel information',
        
        // Dialog
        unsaved_changes_title: 'Unsaved changes',
        unsaved_changes_message: 'Changes made will be lost if you exit without saving',
        unsaved_changes_question: 'Are you sure you want to exit without saving changes to notification configuration?',
    },
    filters: {
        search: 'Search',
        search_placeholder: 'Name, address or code...',
        group: 'Group',
        all_groups: 'All groups',
        active_only: 'Only active',
        inactive_only: 'Only inactive',
        country: 'Country',
        all_countries: 'All countries',
    },
    actions: {
        create: 'New Hotel',
        edit: 'Edit',
        edit_desc: 'Modify basic information',
        delete: 'Delete',
        delete_desc: 'Delete permanently',
        activate: 'Activate',
        deactivate: 'Deactivate',
        manage_zones: 'Manage Zones',
        manage_zones_desc: 'Configure hotel areas',
        manage_texts: 'HMI Texts',
        manage_texts_desc: 'Multilingual customization',
        manage_notifications: 'Notifications',
        manage_notifications_desc: 'Alerts and reports',
        manage_fields: 'Reference Fields',
        manage_fields_desc: 'Identification types',
        view_statistics: 'View statistics',
        view_stats: 'View Statistics',
        disable: 'Disable',
        configure: 'Configure',
        export_data: 'Export data',
        
        // New actions from HotelTexts.tsx
        back_to_config: 'Back to configuration',
        change_logo: 'Change',
        remove: 'Remove',
        upload_logo: 'Upload Logo',
        saving: 'Saving...',
        save_branding: 'Save Branding',
        save_texts: 'Save texts',
        add_language: 'Add Language',
        add_text: 'Add Text',
        add_first_text: 'Add first text',
        delete_text: 'Delete text',
        continue_editing: 'Continue editing',
        exit_without_saving: 'Exit without saving',
        change_language: 'Change language',
        checking: 'Checking...',
        add_default_texts: 'Add default texts',
    },
    messages: {
        no_hotels: 'No hotels registered',
        no_hotels_hint: 'Start by creating your first hotel',
        loading: 'Loading hotels...',
        create_success: 'Hotel created successfully',
        update_success: 'Hotel updated successfully',
        delete_success: 'Hotel deleted successfully',
        delete_confirm: 'Are you sure you want to delete this hotel?',
        activate_success: 'Hotel activated successfully',
        deactivate_success: 'Hotel deactivated successfully',
        installation_code_copied: 'Installation code copied',
        access_denied: 'You do not have permission to view hotels.',
        
        // New messages from HotelTexts.tsx
        unsaved_changes: 'Unsaved changes',
        default_texts_added: 'Default texts added',
        texts_already_exist: 'Texts already exist',
        no_texts_configured: 'No texts configured for this hotel'
    },
    validation: {
        name_required: 'Hotel name is required',
        name_min_length: 'Name must be at least 3 characters',
        name_max_length: 'Name cannot exceed 100 characters',
        name_exists: 'A hotel with this name already exists',
        address_max_length: 'Address cannot exceed 255 characters',
        installation_code_required: 'Installation code cannot be empty',
        installation_code_max_length: 'Installation code cannot exceed 50 characters',
        installation_code_exists: 'A hotel with this installation code already exists',
        invalid_language: 'Invalid language',
        group_required: 'You must select a group',
        email_format: 'Email format is not valid',
        phone_format: 'Phone format is not valid',
        installation_code_format: 'Installation code is not valid',
    },
    dialogs: {
        delete_title: 'Delete Hotel',
        delete_message: 'Are you sure you want to delete the hotel %{name}?',
        delete_warning: 'This action will delete all associated zones, lockers and assignments.',
        delete_cascade_warning: 'This action will delete all associated zones, lockers and assignments.',
        deactivate_title: 'Deactivate Hotel',
        deactivate_message: 'Are you sure you want to deactivate the hotel %{name}?',
        add_text_title: 'Add Custom Text',
        
        // New dialogs from HotelTexts.tsx
        add_language_title: 'Add New Language',
        unsaved_changes_title: 'Unsaved changes',
        unsaved_changes_warning: 'Changes made will be lost if you leave without saving',
        unsaved_both: 'You have unsaved changes in both texts and visual identity.',
        unsaved_texts: 'You have unsaved changes in custom texts.',
        unsaved_branding: 'You have unsaved changes in visual identity.',
        confirm_exit: 'Are you sure you want to exit?',
        unsaved_language_warning: 'You have unsaved changes in the current language',
        change_language_title: 'Change language',
        change_language_message: 'If you change language, you will lose changes made to %{selectedLanguage} language texts. Do you want to continue?',
    },
    tabs: {
        general: 'General Information',
        configuration: 'Configuration',
        zones: 'Zones',
        lockers: 'Lockers',
        statistics: 'Statistics',
        settings: 'Settings',
    },
    status: {
        active: 'Active',
        inactive: 'Inactive',
    },
    sections: {
        basic_info: 'Basic Information',
        basic_info_subtitle: 'Main hotel data',
        basic_info_create_subtitle: 'Main data for the new hotel',
        operation_mode: 'Operation Mode',
        operation_mode_subtitle: 'Access system configuration',
        timing_config: 'Timing Configuration',
        tag_types: 'Supported Tag Types',
        tag_types_subtitle: 'Types of identification accepted by this hotel',
        branding: 'Visual Identity',
        branding_subtitle: 'Customize hotel logo and primary color',
        custom_texts: 'Custom Texts',
        custom_texts_subtitle: 'Customize interface texts in multiple languages',
    },
    help: {
        name: 'Unique name that identifies the hotel',
        group: 'Group to which the hotel belongs',
        address: 'Physical address of the hotel',
        installationCode: 'Format: TAyy1234',
        defaultLanguage: 'Default language for hotel interfaces',
        select_tag_types: 'Select the tag types that the hotel can use for locker access',
        operationMode: 'Operating mode of the locker system',
        emailAssignmentDuration: 'Validity time for email assignments',
        codeExpiration: 'Expiration time for access codes',
        lockerHold: 'Maximum time a locker can be reserved without being used',
        primary_color: 'Main color for the hotel branding interface',
        logo: 'Hotel logo image that will be displayed in the system',
        text_key: 'Format: category.text_name (e.g.: button.submit)',
    },
    notes: {
        after_create: 'After creating the hotel, you can configure zones, assign lockers and manage users.',
    },
    placeholders: {
        select_group: 'Select group',
        name: 'Enter hotel name',
        address: 'Enter hotel address',
        installationCode: 'TAyy1234',
        search_texts: 'Search texts...',
    },
    labels: {
        no_group: 'No group',
    },
    select_group: 'Select group',
    no_groups: ' ',
    notifications: {
        created: 'Hotel created successfully',
        deleted: 'Hotel deleted successfully',
        load_config_error: 'Error loading hotel configuration',
        tag_selection_required: 'Must select at least one tag type for Tag Only mode',
        general_config_updated: 'General configuration updated successfully',
        hotel_updated: 'Hotel updated successfully',
        texts_saved: 'Texts saved successfully',
        texts_save_error: 'Error saving texts',
        brand_config_saved: 'Brand configuration saved successfully',
        brand_config_error: 'Error saving brand configuration',
        text_key_empty: 'Text key cannot be empty',
        text_key_exists: 'This key already exists',
        select_image_file: 'Please select an image file',
        file_size_limit: 'File should not exceed 2MB',
        fields_config_load_error: 'Error loading fields configuration',
        reference_fields_updated: 'Reference fields updated successfully',
        reference_fields_save_error: 'Error saving reference fields',
        max_fields_exceeded: 'Cannot add more than 5 reference fields',
        field_name_required: 'Field name is required',
        field_key_required: 'Field key is required',
        field_key_format_error: 'Key must start with lowercase letter and only contain lowercase letters, numbers and underscores',
        field_key_exists: 'A field with this key already exists',
        no_delete_permission: 'You do not have permission to delete fields',
        notifications_config_load_error: 'Error loading notifications configuration',
        notifications_config_saved: 'Notifications configuration saved successfully',
        notifications_config_save_error: 'Error saving configuration',
    },
    
    // New sections from HotelTexts.tsx
    empty: {
        no_results: 'No texts found matching "%{searchText}"',
        no_texts: 'No texts configured for this language',
    },
    
    info: {
        showing_filtered: 'Showing %{filteredCount} of %{totalCount} texts',
        total_texts: '%{count} texts configured',
    },
    
    alerts: {
        tag_required: 'A tag is required',
    },
    
    errors: {
        create: 'Error creating hotel',
        ensure_texts_failed: 'Error ensuring default texts',
    },
    languages: {
        spanish: 'Español',
        english: 'English',
        french: 'Français',
        german: 'Deutsch',
        italian: 'Italiano',
        portuguese: 'Português',
    },
    zones: {
        title: 'Zone Management',
        subtitle: 'Organize lockers in different hotel areas',
        count: '%{count} zone configured||||%{count} zones configured',
        new_zone: 'New Zone',
        edit_zone: 'Edit Zone',
        delete_zone: 'Delete Zone',
        zone_name: 'Zone Name',
        description: 'Description',
        order: 'Order',
        order_help: 'Order in which the zone will appear',
        cancel: 'Cancel',
        create: 'Create',
        update: 'Update',
        saving: 'Saving...',
        creating: 'Creating...',
        updating: 'Updating...',
        deleting: 'Deleting...',
        delete_confirm: 'Are you sure you want to delete the zone %{name}?',
        delete_warning: 'This zone has %{count} associated lockers. Deleting the zone will also remove these associations.',
        edit: 'Edit',
        delete: 'Delete',
        name_required: 'Zone name is required',
        name_exists: 'A zone with that name already exists',
        created_success: 'Zone created successfully',
        updated_success: 'Zone updated successfully',
        deleted_success: 'Zone deleted successfully',
        create_error: 'Error creating zone',
        update_error: 'Error updating zone',
        delete_error: 'Error deleting zone',
        load_error: 'Error loading hotel zones',
        no_permissions_create: 'You do not have permission to create zones',
        no_permissions_edit: 'You do not have permission to edit zones',
        no_permissions_delete: 'You do not have permission to delete zones',
        no_permissions_save: 'You do not have permission to save zones',
        invalid_hotel_id: 'Invalid hotel ID',
        hotel_load_error: 'Error loading hotel information',
    },
};

export default hotels;
